export default "__VITE_ASSET__423c7879__"